import { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet-async';

// Lazy load heavy components
const HeroSlider = lazy(() => import('@/components/HeroSlider'));
const AnimatedSection = lazy(() => import('@/components/AnimatedSection'));
const AboutSection = lazy(() => import('@/components/sections/AboutSection'));
const ServicesSection = lazy(() => import('@/components/sections/ServicesSection'));
const WhyChooseUsSection = lazy(() => import('@/components/sections/WhyChooseUsSection'));
const TeamSection = lazy(() => import('@/components/sections/TeamSection'));
const TestimonialsSection = lazy(() => import('@/components/sections/TestimonialsSection'));
const BlogSection = lazy(() => import('@/components/sections/BlogSection'));

const Home = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Revolve Solutions - Best Software Development Company</title>
        <meta name="description" content="Revolve Solutions provides innovative software development, cloud migration, data engineering, and business intelligence services. Transform your business with our expert solutions." />
        <meta name="keywords" content="Revolve Solutions, software development company, data engineering services, cloud migration, business intelligence, Yardi services, Deltek Costpoint, UK accounting" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://revolvespl.com" />
        <meta property="og:title" content="Revolve Solutions - Best Software Development Company" />
        <meta property="og:description" content="Transform your business with innovative software solutions, data engineering excellence, and expert cloud migration services from Revolve Solutions." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://revolvespl.com" />
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Revolve Solutions",
        "url": "https://revolvespl.com",
        "description": "Leading software development and data engineering company providing innovative business solutions.",
        "sameAs": [
          "https://www.linkedin.com/company/revolve-solutions",
          "https://twitter.com/revolvesolutions"
        ]
      }
    `}
        </script>
      </Helmet>

      {/* Hero Slider */}
      <Suspense fallback={<div className="h-[600px] flex items-center justify-center">Loading Hero...</div>}>
        <HeroSlider />
      </Suspense>

      {/* About Company Section */}
      <Suspense fallback={<div className="py-10">Loading About...</div>}>
        <AnimatedSection animation="fadeIn" delay={0.1}>
          <AboutSection />
        </AnimatedSection>
      </Suspense>

      {/* Services Section */}
      <Suspense fallback={<div className="py-10">Loading Services...</div>}>
        <AnimatedSection animation="slideUp" delay={0.1}>
          <ServicesSection />
        </AnimatedSection>
      </Suspense>

      {/* Why Choose Us Section */}
      <Suspense fallback={<div className="py-10">Loading Why Choose Us...</div>}>
        <AnimatedSection animation="slideRight" delay={0.1}>
          <WhyChooseUsSection />
        </AnimatedSection>
      </Suspense>

      {/* Leadership Team Section */}
      <Suspense fallback={<div className="py-10">Loading Team...</div>}>
        <AnimatedSection animation="zoomIn" delay={0.1}>
          <TeamSection />
        </AnimatedSection>
      </Suspense>

      {/* Client Testimonials Section */}
      <Suspense fallback={<div className="py-10">Loading Testimonials...</div>}>
        <AnimatedSection animation="slideLeft" delay={0.1}>
          <TestimonialsSection />
        </AnimatedSection>
      </Suspense>

      {/* Recent News/Blog Section */}
      <Suspense fallback={<div className="py-10">Loading Blog...</div>}>
        <AnimatedSection animation="slideUp" delay={0.1}>
          <BlogSection />
        </AnimatedSection>
      </Suspense>
    </div>
  );
};

export default Home;